import {
  Anchor, AlignJustify, Layers, Activity, Sparkles, Scissors, Sun, Droplets,
  Crown, Puzzle, SmilePlus, Stethoscope, ShieldCheck, Users, HeartHandshake,
  ScanLine, Microscope, Star, Plane, GraduationCap, Phone, HelpCircle,
} from "lucide-react";

export const ICONS = {
  Anchor, AlignJustify, Layers, Activity, Sparkles, Scissors, Sun, Droplets,
  Crown, PuzzlePiece: Puzzle, SmilePlus, Stethoscope, ShieldCheck, Users,
  HeartHandshake, ScanLine, Microscope, Star, Plane, GraduationCap, Phone, HelpCircle,
};

export function getIcon(name) {
  return ICONS[name] || ShieldCheck;
}
